module.exports = __webpack_public_path__ + "static/media/phosphor.da905db4.png";